import script from "./RefundSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./RefundSettings.vue?vue&type=script&setup=true&lang=js"

import "./RefundSettings.vue?vue&type=style&index=0&id=32589816&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32589816"]])

export default __exports__